export interface OnboardingFeature {
  rewardType: OnboardingRewardType;
}

export enum OnboardingRewardType {
  Badge = 'badge',
  Cashback = 'cashback',
}
